export const productTranslations = {
  en: {
    "product.backToStore": "Back to Store",
    "product.bookCallTitle": "Book your 30-minute call",
    "product.bookCallDescription": "Pick a time that works for you. Once you've booked your slot, complete your purchase to confirm the session.",
    "product.bookCallButton": "Book a Time on Google Calendar",
    "product.bookingReminder": "💡 Make sure you've selected a time above before completing your purchase.",
    "product.quantity": "Quantity",
    "product.addToCart": "Add to Cart",
    "product.outOfStock": "Out of Stock",
    "product.addedToCartTitle": "Added to cart!",
  },
  zh: {
    "product.backToStore": "返回商店",
    "product.bookCallTitle": "预约您的30分钟通话",
    "product.bookCallDescription": "选择一个适合您的时间。预约成功后，请完成购买以确认此次通话。",
    "product.bookCallButton": "在Google日历上预约时间",
    "product.bookingReminder": "💡 完成购买前，请先在上方选择好时间。",
    "product.quantity": "数量",
    "product.addToCart": "加入购物车",
    "product.outOfStock": "已售罄",
    "product.addedToCartTitle": "已加入购物车！",
  },
} as const;
